/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon20Regular = forwardRef('CheckA2Icon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.39 5.687a.75.75 0 1 0-1.06-1.061l-8.542 8.54a1.234 1.234 0 0 1-1.745 0l-2.71-2.709a.75.75 0 1 0-1.06 1.06l2.71 2.71a2.734 2.734 0 0 0 3.866 0l8.54-8.54Z" }),
        React.createElement("path", { d: "M19.767 5.687a.75.75 0 0 0-1.06-1.061l-9.093 9.092a.75.75 0 0 0 1.06 1.061l9.093-9.092Z" })));
});
